module.exports = __webpack_public_path__ + "static/media/wangyuepeng.3b21c882.png";